import React from "react";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";

import { useNavigate } from "react-router-dom";

import BackIcon from "../../../../assets/svg/BackIcon";
import EvolutionGames from "../../../../assets/images/provider/provider-logo-evolution.png";
import EzugiGames from "../../../../assets/images/provider/provider-logo-ezugi.png";
import AppuGames from "../../../../assets/images/provider/appugames.png";

const LiveDealer = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div>
        <HeaderAfterLogin />
      </div>

      <main className="main">
        <div className="container">
          <div className="live-deal-section">
            <div className="pageHeadingSec">
              <h2>Live Dealer</h2>
              <a href="#" className="back-link" onClick={() => navigate(-1)}>
                Back <BackIcon />
              </a>
            </div>
            <ul>
              <li>
                <a href="/casino/evolution">
                  <img src={EvolutionGames} alt="Providers Logo" />
                </a>
              </li>
              <li>
                <a href="/casino/ezugi">
                  <img src={EzugiGames} alt="Providers Logo" />
                </a>
              </li>
              {/*<li>
                <a href="/casino/supernowa">
                  <img src={AppuGames} alt="Providers Logo" />
                </a>
              </li>*/}
            </ul>
          </div>
        </div>
      </main>

      <div>
        <Footer />
      </div>
    </div>
  );
};

export default LiveDealer;
